var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Horizontal-menu',{staticClass:"horiMenu",attrs:{"page":_vm.route}}),_c('PostsMap',{attrs:{"dataPost":_vm.dataPostData,"dataNext":_vm.dataNextData,"postNotNear":_vm.postNotNearData,"loader":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }